/**
 * Shared chrome for compact table/board toolbars.
 *
 * `toolbarCountBadgeClass` is the small gray count/value pill shown inside a
 * toolbar control — the "(N)" on the Columns button, the "All"/owner count and
 * the "Default" layout value on the Deals board quick-filters. Extracted here so
 * `TableButton` (generic) and the Deals board badge render an identical pill
 * instead of drifting; neither owns the other, so both import from this neutral
 * spot beside ToolbarDensityContext.
 */
export const toolbarCountBadgeClass =
  'rounded-full bg-neutral-100 px-1.5 text-xs font-medium tabular-nums text-neutral-600'
